.kdx-comparison-cards {
    position: relative;

    .kdx-carousel.-cards-slider .glide__slides {
        padding: 30px 20px;
    }
}





@include media-breakpoint-down(xl) {
    .kdx-comparison-cards {

        > .container-fluid {
            > .row {
                margin: 0 auto;
                max-width: none;
    
                [class^="col"] {
                    padding: 0;
                }
            }
        }
    }
}




@include media-breakpoint-down(lg) {
    .kdx-comparison-cards {

        .comparison-card { margin: 5px; }
        .content-wrap { padding: 0 30px; }
        .kdx-carousel {
            padding: 0 0 70px 0;

            &::before, &::after { display: none; }
            &.full-width.-cards-slider {
                .controls button {
                    left: -48px;

                    &.right-btn {
                        left: auto;
                        right: -48px;
                    }
                }
            }
            &.-cards-slider .glide__slides { padding: 30px 0; }
        }
    }
}